function build(txt, img, tre) {
  let struttura = [];
  let temp;
  struttura.push(<h2 className="subtitle">{txt[0]} </h2>);

  temp = <div className="paragrafo">{img[0]}
  {img[1]}</div>;
  struttura.push(temp);

  
  temp = (
    <div className="paragrafo">
      {txt[1]}
    </div>
  );

  struttura.push(temp);

  struttura.push(<h2 className="subtitle">{txt[2]} </h2>);

  temp = <div className="bibliografia">{txt[3]}</div>;
  struttura.push(temp);

  return struttura;
}

export default build;
